<template>
  <div class="flex h-full w-screen items-center justify-center bg-gray-50">
    <div class="flex w-full flex-row">
      <LoginTestimonials />
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import LoginTestimonials from '@/components/LoginTestimonials.vue'
</script>
